import {
  REQUEST_FILTERS,
  RECEIVE_FILTERS, 
} from "./actionTypes";

const initialState = {
  isLoading: false,
  data: {},
};

export const filters = (state = initialState, action) => {
  if(action.type === REQUEST_FILTERS){
    return {
      ...state,
      isLoading: true,
    }
  }
  else if(action.type === RECEIVE_FILTERS){
     return {
       ...state,
       isLoading: false,
       data: action.payload,
     }
  }

  return state;
}